import { msg } from "@omnia/shared/i18n/messages"
import { NutritionVersionService } from "@omnia/shared/nutrition/version/service"
import { ReactAngularComponentContext } from "@omnia/shared/react/angular"
import { DialogBody } from "@omnia/shared/react/DialogBody"
import { DialogFooter } from "@omnia/shared/react/DialogFooter"
import { DialogHeader } from "@omnia/shared/react/DialogHeader"
import { Msg } from "@omnia/shared/react/Msg"
import { showOkCancel } from "@omnia/shared/react/msgbox"
import { IOmniaShell } from "@omnia/types"
import { useMigrationStatus } from "./hooks"
import { Confirmation } from "./Confirmation"


const title = "Upgrade to the new version"

export function MigrateDialog({ dependencies, close }: ReactAngularComponentContext) {

    const $window: ng.IWindowService = dependencies["$window"]
    const shell: IOmniaShell = dependencies["shell"]
    const version: NutritionVersionService = dependencies["version"]
    const session = shell.getSession()

    const { year, currentYear, requestPending } = useMigrationStatus(version, session, 2025)

    const canCommit = (!requestPending) && currentYear && (year !== currentYear)

    const commit = async () => {

        const ok = await showOkCancel(
            (<Confirmation year={year} />),
            msg(title)
        );

        if (ok) {
            await version.setFirstYear(year)
            close()
            $window.location.reload()
        }

    }

    return <div>

        <DialogHeader icon="fas fa-square-up-right">
            <Msg>{title}</Msg>
        </DialogHeader>

        <DialogBody>

            <p>
                This will make the new version of the Nutrition available on this holding for cropping year 2025, copying all current requirements and plans in the process..
            </p>

            <p>
                Please refer to the video below for more details about the process.
            </p>

            <iframe width="560" height="315" frameBorder="0" allowFullScreen={true} src="https://www.youtube.com/embed/XnWTybmQSds">
            </iframe>

        </DialogBody>

        <DialogFooter>


            <button type="button" className="btn btn-warning" onClick={close}>
                Cancel
            </button>

            <button type="button" className="btn btn-primary" onClick={commit} disabled={!canCommit}>
                Confirm
            </button>

        </DialogFooter>

    </div>

}
